exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-12bddd14]:export{menu-bgc-oragne:#F2C46D}[data-v-12bddd14] .vue-select-page .el-select__tags{top:50%;max-height:56px;overflow-y:auto;overflow-x:hidden}[data-v-12bddd14] .vue-select-page .el-select__tags .el-tag--info{height:auto;max-width:100%;display:inline-block;position:relative}[data-v-12bddd14] .vue-select-page .el-select__tags .el-tag--info .el-select__tags-text{line-height:1;display:inline-block;overflow:hidden;white-space:normal;margin-top:4px}[data-v-12bddd14] .vue-select-page .el-select__tags .el-tag--info .el-tag__close.el-icon-close{right:-3px;position:absolute;top:20%}\n", ""]);

// exports
